import React from "react";
import AliceCarousel from 'react-alice-carousel';
import "react-alice-carousel/lib/alice-carousel.css";
import review1 from "../assets/images/desktop/review/person1.png";
import review2 from "../assets/images/desktop/review/person2.png";

import '../styles/components/Reviews.css'

const Reviews = () => {

    const reviews = [
        <div className='figure'>
            <img src={review2} alt='review2'/>
            <div className='caption'>
                <h2>معاذ مارديني / مدير أعمال</h2>
                <p>لوريم ايبسوم دولار سيت أميت ,كونسيكتيتور أدايبا يسكينج أليايت,سيت دو أيوسمود تيمبور
                    يوت انيم أد مينيم فينايم
                    أكسير سيتاشن يللأمكو لابورأس نيس ...
                </p>
            </div>
        </div>,
        <div className='figure'>
            <img src={review1} alt='review1'/>
            <div className='caption'>
                <h2>بلال الشمري / مدير أعمال</h2>
                <p>لوريم ايبسوم دولار سيت أميت ,كونسيكتيتور أدايبا يسكينج أليايت,سيت دو أيوسمود تيمبور
                    يوت انيم أد مينيم فينايم
                    أكسير سيتاشن يللأمكو لابورأس نيس ...</p>
            </div>
        </div>
    ]

    let responsive = {
        986: {
            items: 2,
            itemsFit: 'contain',
        }
    }

    return (
        <>
            <div className='reviews'>
                <h1>آراء العمـلاء</h1>
                <AliceCarousel responsive={responsive} mouseTracking disableButtonsControls={true} items={reviews} />
            </div>
        </>
    )

}

export default Reviews
